/**
 * Manage the Google Address suggestions and autocomplete address fields
 */
(function (root, factory) {
	if ( typeof define === 'function' && define.amd ) {
		define([], factory(root));
	} else if ( typeof exports === 'object' ) {
		module.exports = factory(root);
	} else {
		root.GoogleAddressAutocomplete = factory(root);
	}
})(typeof global !== 'undefined' ? global : this.window || this.global, function (root) {

	'use strict';

	var $ = jQuery;

	var _hasJQuery = ( $ != null );
	var _hasInitialized = false;
	var _publicMethods = { };
	var _settings = {
		bodyClass: 'has-google-autocomplete',

		focusableElementsSelector: 'a[role="button"], a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), textarea:not([disabled]), select:not([disabled]), details, summary, iframe, object, embed, [contenteditable] [tabindex]:not([tabindex="-1"])',
		formRowSelector: '.form-row',
		fieldDescriptionSelector: 'span.description',
		fieldDescriptionClass: 'description',
		select2Selector: '[class*="select2"]',
		countryToStateSelector: 'select.country_to_state, input.country_to_state',
		formRowExpansibleSelector: '.form-row.fc-expansible-form-section',
		formRowExpansibleToggleSelector: '#fc-expansible-form-section__toggle--###FIELD_ID###',
		formRowExpansibleContentSelector: '#fc-expansible-form-section__content--###FIELD_ID###',
		autocompleteInputSelector: '#address_1, #shipping_address_1, #billing_address_1, #company, #shipping_company, #billing_company',
		companyAutocompleteInputSelector: '#company, #shipping_company, #billing_company',
		autocompleteEnabledInputSelector: '.pac-target-input',
		addressGroupSelector: '.woocommerce-shipping-fields, .woocommerce-billing-fields, .woocommerce-address-fields',
		addressGroupShippingSelector: '.woocommerce-shipping-fields',
		addressGroupBillingSelector: '.woocommerce-billing-fields',
		addressFieldsSelector: '[name$="address_1"], [name$="address_2"], [name$="city"], [name$="state"], [name$="postcode"], [name$="country"]:not( input[type="hidden"] )',
		companyFieldsSelector: '[name$="company"]',
		optionalFieldWrapperSelector: '.form-row.fc-expansible-form-section',
		optionalFieldToggleSelector: '.fc-expansible-form-section__toggle',
		optionalFieldContentSelector: '.fc-expansible-form-section__content',
		
		addressFieldsPlaceholderEnabled: 'yes',
		useFieldDescriptionForInstructions: 'no',
		addressFieldsPlaceholder: 'Start typing an address to search...',

		companyAutocompleteValueEnabled: 'no',
		companyAutocompleteInputEnabled: 'no',
		companyFieldsPlaceholderEnabled: 'yes',
		companyFieldsPlaceholder: 'Start typing a business name to search...',

		genericAddressType: 'this',
		addressTypeLabelShipping: 'shipping',
		addressTypeLabelBilling: 'billing',

		maybeSetHiddenFields: 'no',
		hiddenFieldSelectorTemplate: 'form.checkout input[type="hidden"][name="###FIELD_NAME###"]',

		autocompleteDefaultOptions: {
			fields: [ 'type', 'name', 'address_components' ],
			types: [ 'address' ],
		},

		// Set component restrictions for each address lookup field.
		// Example of this accepted values: `allowedCountries: { shipping_address_1: ['US','UK'], }`
		allowedCountries: {},
		countryNotAllowedMessageSelector: '.woocommerce-error.invalid-country-not-allowed',
		countryNotAllowedMessageTemplate: '<span class="woocommerce-error invalid-country-not-allowed">Country {country_name} is not allowed for {address_type} address.</span>',
		invalidMessageClass: 'woocommerce-invalid',
		invalidMessageCountryNotAllowedClass: 'woocommerce-invalid-country-not-allowed-field',

		// Keys based on component names from Google Place data
		componentValueType: {
			subpremise: 'short_name',
			street_number: 'short_name',
			route: 'long_name',
			locality: 'long_name',
			sublocality_level_1: 'long_name',
			sublocality_level_2: 'long_name',
			sublocality_level_3: 'long_name',
			administrative_area_level_1: 'short_name',
			administrative_area_level_2: 'short_name',
			administrative_area_level_3: 'short_name',
			administrative_area_level_4: 'short_name',
			country: 'short_name',
			postal_town: 'long_name',
			postal_code: 'short_name',
		},

		// Keys: based on WooCommerce forms field ids.
		// Values: based on component names from Google Place data.
		//
		// IMPORTANT: Uses only the first component type from Google Place data to be more specific and avoid duplicate values.
		//
		// Each locale defined at the server via PHP with filter `fc_gaa_google_autocomplete_js_settings` for customizations.
		// @see `/inc/google-address-autocomplete.php` at function `add_js_settings`.
		localeComponents: {
			// Default to most used formats
			default: {
				country_name: 'country_name',
				country: 'country',
				postcode: 'postal_code',
				state: 'administrative_area_level_1',
				city: 'locality',
				fallback_city: 'sublocality_level_1',
				address_1: [ 'route', 'street_number' ],
				components_separator: ' ',
				subpremise_separator_position: 'after', // Accepted values `before` and `after`
				subpremise_separator_before: '',
				subpremise_separator_after: '/',
			},
		},

		defaultLocale: 'US',

		debugMode: false,

	};


	/**
	 * METHODS
	 */



	/*!
	* Merge two or more objects together.
	* (c) 2017 Chris Ferdinandi, MIT License, https://gomakethings.com
	* @param   {Boolean}  deep     If true, do a deep (or recursive) merge [optional]
	* @param   {Object}   objects  The objects to merge together
	* @returns {Object}            Merged values of defaults and options
	*/
	var extend = function () {
		// Variables
		var extended = {};
		var deep = false;
		var i = 0;

		// Check if a deep merge
		if ( Object.prototype.toString.call( arguments[0] ) === '[object Boolean]' ) {
			deep = arguments[0];
			i++;
		}

		// Merge the object into the extended object
		var merge = function (obj) {
			for (var prop in obj) {
				if (obj.hasOwnProperty(prop)) {
					// If property is an object, merge properties
					if (deep && Object.prototype.toString.call(obj[prop]) === '[object Object]') {
						extended[prop] = extend(extended[prop], obj[prop]);
					} else {
						extended[prop] = obj[prop];
					}
				}
			}
		};

		// Loop through each object and conduct a merge
		for (; i < arguments.length; i++) {
			var obj = arguments[i];
			merge(obj);
		}

		return extended;
    };



	/**
	 * Set address field value.
	 *
	 * @param   {HTMLElement}    field  Form field.
	 * @param   {Object}         value  Value to set for the form field.
	 */
	var setFieldValue = function( field, value ) {
		// Bail if field not provided
		if ( ! field ) { return; }

		// Sanitize value
		value = value == undefined || value == null ? '' : value;

		// Set field value
		field.value = value;

		// Set field value for select2 fields
		if ( _hasJQuery && field.matches( _settings.select2Selector ) ) {
			$( field ).val( value );
			$( field ).trigger( 'change.select2' );

			// Maybe log event
			if ( 'yes' == _settings.debugMode ) {
				console.log( 'Event `change.select2` triggered.' );
				console.log( field );
			}
		}

		// Maybe set value for equivalent hidden field
		if ( 'yes' === _settings.maybeSetHiddenFields ) {
			var hiddenFieldSelector = _settings.hiddenFieldSelectorTemplate.replace( '###FIELD_NAME###', field.name );
			var hiddenField = document.querySelector( hiddenFieldSelector );
			if ( hiddenField ) {
				hiddenField.value = value;

				// Maybe log event
				if ( 'yes' == _settings.debugMode ) {
					console.log( 'Hidden field `' + field.name + '`: ' + value );
				}
			}
		}

		// Maybe trigger `change` event for country to state fields
		if ( _hasJQuery && field.matches( _settings.countryToStateSelector ) ) {
			$( field ).trigger( 'change' );

			// Maybe log event
			if ( 'yes' == _settings.debugMode ) {
				console.log( 'Event `change` triggered for country to state field.' );
				console.log( field );
			}
		}

		// Try to expand or collapse optional fields
		if ( window.CollapsibleBlock && field.closest( _settings.formRowExpansibleSelector ) ) {
			var formRow = field.closest( _settings.formRowExpansibleSelector );
			var fieldCollapsibleToggle = formRow.querySelector( _settings.formRowExpansibleToggleSelector.replace( '###FIELD_ID###', field.id ) );
			var fieldCollapsibleContent = formRow.querySelector( _settings.formRowExpansibleContentSelector.replace( '###FIELD_ID###', field.id ) );

			// Maybe expand field content section
			var hasValue = null !== value && '' !== value;
			if ( hasValue ) {
				CollapsibleBlock.collapse( fieldCollapsibleToggle, false ); // Collapse without transitions
				CollapsibleBlock.expand( fieldCollapsibleContent, false, false ); // Expand without transitions and without setting focus
			}
			// Otherwise field content section
			else {
				CollapsibleBlock.expand( fieldCollapsibleToggle, false, false ); // Expand without transitions and without setting focus
				CollapsibleBlock.collapse( fieldCollapsibleContent, false ); // Collapse without transitions
			}
		}

		// Clear validation status
		// If Fluid Checkout checkout validation script is available
		if ( window.CheckoutValidation ) {
			CheckoutValidation.clearValidationResults( field, field.closest( _settings.formRowSelector ) );
		}

		// Trigger field `validate` event
		if ( _hasJQuery ) {
			$( field ).trigger( 'validate' );
		}
	}



	/**
	 * Remove the country not allowed validation message.
	 * 
	 * @param   {HTMLElement}    groupElement  Element containing the address form field.
	 */
	var removeCountryNotAllowedMessage = function( groupElement ) {
		// Remove country not allowed error message
		var countryNotAllowedMessage = groupElement.querySelector( _settings.countryNotAllowedMessageSelector );

		if ( countryNotAllowedMessage ) {
			// Add validation classes to form row
			var formRow = countryNotAllowedMessage.closest( _settings.formRowSelector );
			formRow.classList.remove( _settings.invalidMessageClass );
			formRow.classList.remove( _settings.invalidMessageCountryNotAllowedClass );

			// Remove message element
			countryNotAllowedMessage.parentNode.removeChild( countryNotAllowedMessage );
		}
	}



	/**
	 * Display the country not allowed validation message.
	 *
	 * @param   {Object}        place   Google Place data.
	 * @param   {HTMLElement}   input   Address lookup field element.
	 */
	var displayCountryNotAllowedMessage = function( place, input ) {
		// Get country long name
		var countryName = getFieldLongNameFromPlace( 'country', place );

		// Get address type
		var addressType = _settings.genericAddressType;
		if ( input.closest( _settings.addressGroupShippingSelector ) ) { addressType = _settings.addressTypeLabelShipping; }
		if ( input.closest( _settings.addressGroupBillingSelector ) ) { addressType = _settings.addressTypeLabelBilling; }

		// Get message html and append to page
		var messageHtml = _settings.countryNotAllowedMessageTemplate;
		messageHtml = messageHtml.replace( '{country_name}', countryName );
		messageHtml = messageHtml.replace( '{address_type}', addressType );
		input.insertAdjacentHTML( 'afterend', messageHtml );

		// Add validation classes to form row
		var formRow = input.closest( _settings.formRowSelector );
		formRow.classList.add( _settings.invalidMessageClass );
		formRow.classList.add( _settings.invalidMessageCountryNotAllowedClass );
	}



	/**
	 * Clear address form fields
	 * 
	 * @param   {HTMLElement}    groupElement  Element containing the address form field.
	 */
	var cleanAddressFields = function( groupElement ) {
		// Bail if address book element not passed
		if ( ! groupElement ) { return; }

		window.can_update_checkout = false;

		// Iterate address form fields
		var fields = groupElement.querySelectorAll( _settings.addressFieldsSelector );
		for ( var i = 0; i < fields.length; i++ ) {
			var field = fields[i];
			setFieldValue( field, '' );
		}

		// Remove country not allowed validation message
		removeCountryNotAllowedMessage( groupElement );

		window.can_update_checkout = true;
	}



	/**
	 * Get the next focusable element in the address group.
	 * 
	 * @param  {HTMLElement}  input  The current input field. 
	 */
	var getNextFocusableElement = function( input ) {
		// Bail if `input` is not valid
		if ( ! input ) { return; }

		var groupElement = input.closest( _settings.addressGroupSelector );

		// Bail if `groupElement` is not valid
		if ( ! groupElement ) { return; }

		// Get and iterate focusable elements within the group element
		var focusableElements = groupElement.querySelectorAll( _settings.focusableElementsSelector );
		for ( var i = 0; i < focusableElements.length; i++ ) {
			var element = focusableElements[ i ];
			
			// Find the current element in the list
			if ( element === input ) {
				// Check whether there are any other focusable elements after the current one
				var nextElementIndex = i + 1;
				if ( nextElementIndex >= focusableElements.length ) { return; }

				// Get and return the next element in the list
				var nextFocusableElement = focusableElements[ nextElementIndex ];
				return nextFocusableElement;
			}
		}

		return;
	}



	/**
	 * Get country locale settings for address fields from Google Place data.
	 *
	 * @param   {string}  countryCode  Country code to get locale settings for.
	 *
	 * @return  {Object}               Full locale settings for the country.
	 */
	var getLocale = function( countryCode ) {
		var locale = _settings.localeComponents.default;

		// Get full locale settings for the country
		if ( countryCode != null && _settings.localeComponents.hasOwnProperty( countryCode.toUpperCase() ) ) {
			locale = extend( locale, _settings.localeComponents[ countryCode.toUpperCase() ] );
		}

		return locale;
	}

	/**
	 * Get the value of a field mapped from Google Place data to the values used by WooCommerce.
	 *
	 * @param   {string}  value           The current value for the field.
	 * @param   {string}  fieldId         Form field id to get data for.
	 * @param	  {string}  country         Country code of the locale.
	 *
	 * @return  {string}                  The field value mapped to WooCommerce values, or the current value of the field if no mapping is available for the field.
	 */
	var getMappedFieldValue = function ( value, fieldId, country ) {
		// Bail if settings do not have field value mappings
		if ( ! _settings.hasOwnProperty( 'localeFieldValueMapping' ) ) { return value; }

		var localeMapping = _settings.localeFieldValueMapping[ country ];

		// Bail if mapping not available for the country
		if ( ! localeMapping ) { return value; }

		var fieldMapping = localeMapping[ fieldId ];

		// Bail if mapping not available for the field
		if ( ! fieldMapping ) { return value; }

		// Get mapped value
		var mappedValue = fieldMapping[ value ];

		// Maybe log field details
		if ( 'yes' == _settings.debugMode ) {
			console.log( 'mapped fieldId: ' + fieldId );
			console.log( 'mapped value: ' + mappedValue );
			console.log( 'value: ' + value );
		}

		// Maybe use original value when a mapped value is not available
		if ( undefined === mappedValue || null === mappedValue ) {
			mappedValue = value;

			if ( 'yes' == _settings.debugMode ) {
				console.log( 'using original value: ' + value );
			}
		}

		return mappedValue;
	}

	/**
	 * Get the value for field component from the Google Place data.
	 *
	 * @param   {string}  fieldId         Form field id to get data for.
	 * @param   {string}  fieldComponent  ID of the field component to get data for.
	 * @param   {Object}  place           Google Place data.
	 * @param	  {string}  country         Country code of the locale.
	 *
	 * @return  {string}                  The field component value from the place data.
	 */
	var getFieldComponentValueFromPlace = function( fieldId, fieldComponent, place, country ) {
		// Bail if place does not have address components
		if ( ! place || ! place.address_components ) { return; }

		// Iterate place address components and return the first match
		for ( var i = 0; i < place.address_components.length; i++ ) {
			var component = place.address_components[ i ];
			var fieldType = component.types[0]; // IMPORTANT: Uses only the first component type from Google Place data to be more specific and avoid duplicate values.

			if ( fieldComponent == fieldType ) {
				var fieldValue = component[ _settings.componentValueType[ fieldType ] ];
				return getMappedFieldValue( fieldValue, fieldId, country );
			}
		}

		return null;
	}

	/**
	 * Get the value for an address field from the Google Place data based on the locale.
	 *
	 * @param   {string}  fieldId  Form field id to get data for.
	 * @param   {Object}  place    Google Place data.
	 * @param	  {string}  locale   The field components settings for the country.
	 * @param	  {string}  country  Country code of the locale.
	 *
	 * @return  {string}           Localized value for the form field.
	 */
	var getFieldValueFromPlace = function( fieldId, place, locale, country ) {

		// Bail if place does not have address components
		if ( ! place || ! place.address_components ) { return; }

		var valuesBefore = [];
		var valuesAfter = [];
		var valueString = '';
		
		// Get default locale if not passed in
		if ( ! locale ) {
			locale = _settings.localeComponents.default;
		}

		// Get `fieldComponents` as an Array
		var fieldComponents = locale[ fieldId ];
		if ( ! Array.isArray( fieldComponents ) ) { fieldComponents = [ fieldComponents ]; }

		// Get whether `subpremise` is used for the field
		var hasSubpremise = fieldComponents.includes( 'subpremise' );
		var subpremiseIndex = fieldComponents.indexOf( 'subpremise' );

		// Get field components list for before and after the `subpremise`
		// When the field does not use the subpremise component,
		// all components are handled with the `fieldComponentsAfter` variable, as if they were all `after` an empty subpremise.
		var fieldComponentsBefore = fieldComponents.slice( 0, subpremiseIndex );
		var fieldComponentsAfter = fieldComponents.slice( subpremiseIndex + 1 );

		// Handle subpremise and values before it
		if ( hasSubpremise ) {
			// Get values before the subpremise
			fieldComponentsBefore.forEach( function( fieldComponent ) {
				valuesBefore.push( getFieldComponentValueFromPlace( fieldId, fieldComponent, place, country ) );
			} );

			// Append values before the subpremise
			valueString = valuesBefore.join( locale.components_separator );

			// Get subpremise value
			var subpremiseValue = getFieldComponentValueFromPlace( fieldId, 'subpremise', place, country );

			// Add subpremise value and separators
			if ( null !== subpremiseValue ) {
				valueString = valueString + locale.subpremise_separator_before;
				valueString = valueString + subpremiseValue;
				valueString = valueString + locale.subpremise_separator_after;
			}
		}

		// Get values after the subpremise
		fieldComponentsAfter.forEach( function( fieldComponent ) {
			var fieldComponentValue = getFieldComponentValueFromPlace( fieldId, fieldComponent, place, country );
			if ( null !== fieldComponentValue && '' !== fieldComponentValue ) {
				valuesAfter.push( fieldComponentValue );
			}
		} );

		// Append values after the subpremise
		valueString = valueString + valuesAfter.join( locale.components_separator );

		return valueString;
	}



	/**
	 * Get the `long_name` value for an address field from the Google Place data based on the locale.
	 *
	 * @param   {string}  fieldId  Form field id to get data for.
	 * @param   {Object}  place    Google Place data
	 * @param	  {string}  locale   Country code of the locale.
	 *
	 * @return  {string}           Localized value for the form field.
	 */
	var getFieldLongNameFromPlace = function( fieldId, place, locale ) {

		// Bail if place does not have address components
		if ( ! place || ! place.address_components ) { return; }

		var values = [];
		
		// Get default locale if not passed in
		if ( ! locale ) {
			locale = _settings.localeComponents.default;
		}

		// Get `fieldComponents` as an Array
		var fieldComponents = locale[ fieldId ];
		if ( ! Array.isArray( fieldComponents ) ) { fieldComponents = [ fieldComponents ]; }

		fieldComponents.forEach( function( fieldComponent ) {
			for ( var i = 0; i < place.address_components.length; i++ ) {
				var component = place.address_components[ i ];
				var fieldType = component.types[0];

				if ( fieldComponent == fieldType ) {
					var fieldValue = component[ 'long_name' ];
					values.push( fieldValue );
					break; // Exit place address components iteration when value is found
				}
			}
		} );

		return values.join( locale.components_separator );
	}



	/**
	 * Get the allowed countries for an Address Autocomplete lookup field.
	 *
	 * @param   {HTMLElement}   input   Address lookup field element.
	 *
	 * @return  {Array}                 A list of countries allowed for the address lookup input field. `Null` on error getting the values.
	 */
	var getAllowedCountriesForInput = function( input ) {
		// Bail if input not valid or group element not available
		if ( ! input || ! input.closest( _settings.addressGroupSelector ) ) { return; }
		
		var groupElement = input.closest( _settings.addressGroupSelector );

		// Bail if group element not found
		if ( ! groupElement ) { return; }

		var countryField = groupElement.querySelector( '[id$="country"]' );

		// Bail if country field not found
		if ( ! countryField ) { return; }
		
		var allowedCountries = [];

		// Get allowed country codes from country select field
		if ( countryField.type != 'hidden' ) {
			var countryOptions = groupElement.querySelectorAll( '[id$="country"] option' );
			for ( var i = 0; i < countryOptions.length; i++ ) {
				var option = countryOptions[i];
				if ( option.value != '' ) { allowedCountries.push( option.value ); }
			}
		}
		// Handle only one allowed country
		else if ( countryField.value != '' ) {
			allowedCountries.push( countryField.value );
		}

		return allowedCountries;
	}



	/**
	 * Fill address form field values from the selected place.
	 *
	 * @param   {Object}                            place          Google Place data.
	 * @param   {HTMLElement}                       input          Address lookup field element.
	 * @param   {google.maps.places.Autocomplete}   autocomplete   Google Maps Autocomplete object.
	 */
	var fillAddressFields = function( place, input, autocomplete ) {
		var groupElement = input.closest( _settings.addressGroupSelector );

		// Get country values
		var countryField = groupElement.querySelector( '[id$="country"]' );
		var countryValue = getFieldValueFromPlace( 'country', place ) || _settings.defaultLocale;
		var allowedCountries = getAllowedCountriesForInput( input );

		// Check if country is allowed, display validation message otherwise
		if ( countryField.type != 'hidden' && ! allowedCountries.includes( countryValue ) ) {
			displayCountryNotAllowedMessage( place, input );
			return;
		}

		// Clear previous address field values
		cleanAddressFields( groupElement );

		// Set country field value, except when field type is `hidden` in which case country value can't be changed
		if ( countryField.type != 'hidden' ) {
			setFieldValue( countryField, countryValue );
		}

		requestAnimationFrame( function() {
			// Set address field values to the selected place
			var locale = getLocale( countryValue );
			var fieldIds = Object.getOwnPropertyNames( locale );
			for ( var i = 0; i < fieldIds.length; i++ ) {
				var fieldId = fieldIds[ i ];

				// Skip components separator
				if ( fieldId == 'components_separator' ) { continue; }
				
				// Skip country field as it has already been set
				if ( fieldId == 'country' ) { continue; }

				// Skip fallback fields
				if ( 0 === fieldId.indexOf( 'fallback_' ) ) { continue; }
				
				// Get field
				var field = groupElement.querySelector( 'input[id$="'+fieldId+'"], textarea[id$="'+fieldId+'"], select[id$="'+fieldId+'"]' );

				// Skip if field was not found
				if ( ! field ) { continue; }

				// Get value and fallback value
				var fieldIdFallback = 'fallback_' + fieldId;
				var value = getFieldValueFromPlace( fieldId, place, locale, countryValue );
				var valueFallback = ( null === value || '' === value ) && locale.hasOwnProperty( fieldIdFallback ) ? getFieldValueFromPlace( fieldIdFallback, place, locale ) : null;

				// Maybe log field details
				if ( 'yes' == _settings.debugMode ) {
					console.log( 'fieldId: ' + fieldId );
					console.log( 'value: ' + value );
					if ( null !== valueFallback ) { console.log( 'valueFallback: ' + valueFallback ); }
					console.log( field );
				}

				// Maybe replace value with fallback
				if ( null === value || '' === value ) { value = valueFallback; }
				
				// Set state field to uppercase to match values from WooCommerce
				if ( fieldId == 'state' && ( field.type.indexOf( 'select' ) > -1 ) && null !== value ) { value = value.toUpperCase(); }

				setFieldValue( field, value );
			}
		} );
	}

	/**
	 * Maybe fill company form field value from the selected place.
	 *
	 * @param   {Object}                            place          Google Place data.
	 * @param   {HTMLElement}                       input          Address lookup field element.
	 * @param   {google.maps.places.Autocomplete}   autocomplete   Google Maps Autocomplete object.
	 */
	var maybeFillCompanyField = function( place, input, autocomplete ) {
		// Bail if company name autocomplete is disabled
		if ( 'yes' !== _settings.companyAutocompleteValueEnabled ) { return; }

		var groupElement = input.closest( _settings.addressGroupSelector );

		// Bail if group element is not available
		if ( ! groupElement ) { return; }

		// Bail if place is not an establishment
		if ( ! place.name || ! place.types || ! place.types.includes( 'establishment' ) ) { return;}

		// Get company field
		var companyField = groupElement.querySelector( _settings.companyFieldsSelector );

		// Bail if company field not found
		if ( ! companyField ) { return; }

		// Set company field value to the selected place
		var value = place.name;
		setFieldValue( companyField, value );

		// Maybe log field details
		if ( 'yes' == _settings.debugMode ) {
			// Maybe log
			console.log( 'fieldId: company' );
			console.log( 'value: ' + value );
			console.log( companyField );
		}
	}



	/**
	 * Effectively disable the browser autocomplete feature by changing the input `autocomplete` attribute to a random value.
	 *
	 * @param   {HTMLElement}  input  Input field to disable the browser autocomplete feature.
	 */
	var disableBrowserAutocomplete = function( input ) {
		// Bail if input is invalid
		if ( ! input ) { return; }

		input.setAttribute( 'autocomplete', 'off-' + Date.now() );
	}

	/**
	 * Restore the browser autocomplete feature by changing the input `autocomplete` attribute to its original value.
	 *
	 * @param   {HTMLElement}  input  Input field to restore the browser autocomplete feature.
	 */
	var restoreAutocompleteAttr = function( input ) {
		// Bail if input is invalid
		if ( ! input ) { return; }

		input.setAttribute( 'autocomplete', input.getAttribute( 'data-o-autocomplete' ) );
	}

	/**
	 * Maybe restore the browser autocomplete feature.
	 *
	 * @param   {HTMLElement}  input  Input field to restore the browser autocomplete feature.
	 */
	var maybeRestoreAutocompleteAttr = function( input ) {
		// Bail if input is invalid of already restored
		if ( ! input || input.getAttribute( 'autocomplete' ) != 'off' ) { return; }

		restoreAutocompleteAttr( input );
	}



	/**
	 * Prevent form submit when `Enter` key is pressed to select an address suggestion.
	 *
	 * @param   {Event}   e  Keydown event.
	 *
	 * @return  {Boolean}    Return `false` to prevent event to complete execution, nothing otherwise.
	 */
	var maybePreventFormSubmit = function( e ) {
		// Prevent form submit when `Enter` key is pressed to select an address suggestion
		if ( e.key == 'Enter' || e.which == 13 ) {
			e.preventDefault();
			return false;
		}
	}



	/**
	 * Initialize Google Address Autocomplete for an address lookup field.
	 *
	 * @param   {HTMLElement}  input  Address lookup field element.
	 */
	var initField = function( input ) {
		// Bail if input invalid
		if ( ! input ) { return; }

		// Bail if is company field and option to search through company field is disabled
		if ( input.matches( _settings.companyFieldsSelector ) && 'yes' !== _settings.companyAutocompleteInputEnabled ) { return; }

		var groupElement = input.closest( _settings.addressGroupSelector );

		// Bail if group element not found
		if ( ! groupElement ) { return; }

		var countryField = groupElement.querySelector( '[id$="country"]' );

		// Bail if country field not found
		if ( ! countryField ) { return; }

		// Get autocomplete options
		var autocompleteOptions = extend( true, [], _settings.autocompleteDefaultOptions ); // Clone options object
		var allowedTypes = [ '', 'address', 'geocode', 'establishment', '(regions)', '(cities)' ];
		var allowedCountriesList;

		// Sanitize result types
		for ( var i = 0; i < autocompleteOptions.types.length; i++ ) {
			var type = autocompleteOptions.types[i];
			if ( ! allowedTypes.includes( type ) ) {
				console.warn( 'Invalid values for `autocompleteOptions.types`, assuming `address`.' );
				autocompleteOptions.types = [ 'address' ];
				break;
			}
		}

		// Although the option `autocompleteOptions.types` is expected to be an array, it can only contain one value
		if ( autocompleteOptions.types.length > 1 ) {
			console.warn( 'Option `autocompleteOptions.types` can only have one value specified, assuming `address`.' );
			autocompleteOptions.types = [ 'address' ];
		}

		// Try get allowed countries from settings
		if ( _settings.allowedCountries.hasOwnProperty( input.id ) ) {
			allowedCountriesList = _settings.allowedCountries[ input.id ];
		}
		// Try get/set allowed countries from country select field options
		else {
			allowedCountriesList = getAllowedCountriesForInput( input );
			if ( allowedCountriesList.length > 5 ) {
				allowedCountriesList = null;
			}
		}

		// Maybe set country restrictions
		if ( Array.isArray( allowedCountriesList ) ) {
			autocompleteOptions[ 'componentRestrictions' ] = { country: allowedCountriesList };
		}

		// Get/Set original value of the `autocomplete` attribute
		input.setAttribute( 'data-o-autocomplete', input.getAttribute( 'autocomplete' ) );

		// Get field description element
		var formRow = input.closest( _settings.formRowSelector );
		var fieldDescription = formRow.querySelector( _settings.fieldDescriptionSelector );
		var shouldInsertDescription = false;

		// Maybe create field description element
		if ( ! fieldDescription ) {
			fieldDescription = document.createElement( 'span' );
			fieldDescription.id = input.id + '-description';
			fieldDescription.classList.add( _settings.fieldDescriptionClass );
			shouldInsertDescription = true;
		}

		// Maybe set field placeholder text
		if ( 'yes' === _settings.addressFieldsPlaceholderEnabled && ! input.matches( _settings.companyAutocompleteInputSelector ) ) {
			if ( 'yes' === _settings.useFieldDescriptionForInstructions ) {
				// Maybe set field description text
				if ( ! fieldDescription.innerHTML.includes( _settings.addressFieldsPlaceholder ) ) {
					fieldDescription.innerHTML = fieldDescription.innerHTML + ( fieldDescription.innerHTML.toString() == '' || fieldDescription.innerHTML.endsWith( '.' )  ? ' ' : '. ' );
					fieldDescription.innerHTML = fieldDescription.innerHTML + _settings.addressFieldsPlaceholder;
				}

				// Maybe insert field description element
				if ( shouldInsertDescription ) {
					input.parentElement.appendChild( fieldDescription );
				}
			}
			else {
				input.setAttribute( 'placeholder', _settings.addressFieldsPlaceholder );
			}
		}

		// Handle search for company field
		if ( input.matches( _settings.companyAutocompleteInputSelector ) ) {
			// Maybe set company field search types to `establishment`
			if ( 'yes' === _settings.companyAutocompleteInputEnabled ) {
				autocompleteOptions.types = [ 'establishment' ];
			}

			// Maybe set company field placeholder text
			if ( 'yes' === _settings.companyFieldsPlaceholderEnabled ) {
				if ( 'yes' === _settings.useFieldDescriptionForInstructions ) {
					// Maybe set field description text
					if ( ! fieldDescription.innerHTML.includes( _settings.companyFieldsPlaceholder ) ) {
						fieldDescription.innerHTML = fieldDescription.innerHTML + ( fieldDescription.innerHTML.toString() == '' || fieldDescription.innerHTML.endsWith( '.' )  ? ' ' : '. ' );
						fieldDescription.innerHTML = fieldDescription.innerHTML + _settings.companyFieldsPlaceholder;
					}
	
					// Maybe insert field description element
					if ( shouldInsertDescription ) {
						input.parentElement.appendChild( fieldDescription );
					}
				}
				else {
					input.setAttribute( 'placeholder', _settings.companyFieldsPlaceholder );
				}
			}
		}

		// Maybe initialize Google Places Autocomplete for the input field
		if ( ! input.matches( _settings.autocompleteEnabledInputSelector ) ) {
			// Initialize Google Places Autocomplete
			var autocomplete = new google.maps.places.Autocomplete( input, autocompleteOptions );
			var onPlaceChange = function() {
				var place = autocomplete.getPlace();

				// Maybe log place details
				if ( 'yes' == _settings.debugMode ) {
					console.log( place );
				}

				// Check if user selected an address
				if ( place.address_components ) {
					// Fill address fields
					fillAddressFields( place, input, autocomplete );
					maybeFillCompanyField( place, input, autocomplete );

					// Try to set focus to next focusable element
					var nextFocusableElement = getNextFocusableElement( input );
					if ( nextFocusableElement ) {
						nextFocusableElement.focus();
					}

					// Wait for the next frame to trigger checkout update event
					requestAnimationFrame( function() {
						if ( _hasJQuery ) {
							// Trigger checkout update event
							$( document.body ).trigger( 'update_checkout' );

							// Maybe log
							if ( 'yes' == _settings.debugMode ) {
								console.log( 'Update checkout triggered' );
							}
						}
					} );
				}
			}

			// Set event handler for suggestion selected/changed
			autocomplete.addListener( 'place_changed', onPlaceChange );

			// Attempt to disable browser autocomplete for the input field.
			// This is a hacky way to restore autocomplete values after initializing the Google Places Autocomplete component,
			// a better approach would be to listen to an event from the API but at the time of making this the only event
			// available is `place_changed` which won't work for this purpose.
			// @see https://developers.google.com/maps/documentation/javascript/reference/places-widget#Autocomplete
			setTimeout( function(){ maybeRestoreAutocompleteAttr( input ); }, 1000 );
			setTimeout( function(){ maybeRestoreAutocompleteAttr( input ); }, 2000 );
			setTimeout( function(){ maybeRestoreAutocompleteAttr( input ); }, 5000 );
		}
	}



	/**
	 * Initialize Google Address Autocomplete for all address lookup fields.
	 */
	var initFields = function() {
		setTimeout( function() {
			var inputs = document.querySelectorAll( _settings.autocompleteInputSelector );
			inputs.forEach( initField );
		}, 16 ); // Arbitrary delay to allow other scripts to run first
	}



	/**
	 * Handle captured `focus` event and route to the appropriate functions.
	 *
	 * @param   {Event}  e  Event dispatched. Usually `focus` or `focusin`.
	 */
	var handleFocus = function( e ) {
		if ( e.target.matches( _settings.autocompleteEnabledInputSelector ) ) {
			disableBrowserAutocomplete( e.target );
		}
	}
	


	/**
	 * Handle captured `blur` event and route to the appropriate functions.
	 *
	 * @param   {Event}  e  Event dispatched. Usually `blur` or `focusout`.
	 */
	var handleBlur = function( e ) {
		if ( e.target.matches( _settings.autocompleteEnabledInputSelector ) ) {
			restoreAutocompleteAttr( e.target );
		}
	}



	/**
	 * Handle captured `keydown` event and route to the appropriate functions.
	 *
	 * @param   {Event}  e  Keydown event dispatched.
	 */
	var handleKeydown = function( e ) {
		// Pressing `Enter`
		if ( e.target.matches( _settings.autocompleteEnabledInputSelector ) ) {
			maybePreventFormSubmit( e );
		}

		// Clear country allowed message on address field change
		if ( e.target.matches( _settings.autocompleteInputSelector ) ) {
			var groupElement = e.target.closest( _settings.addressGroupSelector );
			removeCountryNotAllowedMessage( groupElement );
		}
	}



	/**
	 * Initialize component and set related handlers.
	 * 
	 * @param   {Object}   options  Pass different settings values for initializing this component.
	 */
	_publicMethods.init = function( options ) {
		if ( _hasInitialized ) return;

		// Try to get options from the plugin settings JS object
		if ( ! options && window.fcGAASettings && window.fcGAASettings.googleAutoCompleteSettings ) {
			options = window.fcGAASettings.googleAutoCompleteSettings;
		}

		// Merge settings
		_settings = extend( true, _settings, options );

		// Initialize address autocomplete fields
		initFields();
		if ( _hasJQuery ) {
			// Re-initialize address autocomplete fields after `updated_checkout`
			$( document.body ).on( 'updated_checkout', initFields );
			$( document.body ).on( 'country_to_state_changing', initFields );
		}

		// Add event listeners
		window.addEventListener( 'focusin', handleFocus );
		window.addEventListener( 'focusout', handleBlur );
		window.addEventListener( 'keydown', handleKeydown, true );

		// Finish initialization
		document.body.classList.add( _settings.bodyClass );
		_hasInitialized = true;
	};



	//
	// Public APIs
	//
	return _publicMethods;

});
